import WaypointPopup from './WaypointPopup';

export default WaypointPopup;
